// removed by extract-text-webpack-plugin
module.exports = {"forgotPassword":"ForgotPassword__forgotPassword","buttonContainer":"ForgotPassword__buttonContainer","growDotQello":"ForgotPassword__growDotQello","growDotBlue":"ForgotPassword__growDotBlue","growDotGolden":"ForgotPassword__growDotGolden"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/ForgotPassword/ForgotPassword.scss
// module id = 1904
// module chunks = 0